import { useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Sidebar from "./Sidebar";
import TopHeader from "./TopHeader";
import CommandPalette from "./CommandPalette";

export default function AppShell() {
  const [collapsed, setCollapsed] = useState(
    () => typeof window !== "undefined" && window.matchMedia("(max-width: 767px)").matches
  );
  const [paletteOpen, setPaletteOpen] = useState(false);
  const location = useLocation();

  // Register global cmd+k listener
  if (typeof window !== "undefined" && !window.__pleiadesCmdK) {
    window.__pleiadesCmdK = true;
    window.addEventListener("keydown", (e) => {
      if ((e.metaKey || e.ctrlKey) && e.key.toLowerCase() === "k") {
        e.preventDefault();
        window.dispatchEvent(new CustomEvent("pleiades:open-cmd"));
      }
    });
  }

  if (typeof window !== "undefined" && !window.__pleiadesCmdListener) {
    window.__pleiadesCmdListener = true;
  }

  return (
    <div className="h-screen h-[100dvh] w-full overflow-hidden flex bg-pleiades-ivory text-pleiades-ink" data-testid="app-shell">
      <Sidebar collapsed={collapsed} onToggle={() => setCollapsed((v) => !v)} />
      <div className="flex-1 min-h-0 flex flex-col min-w-0">
        <TopHeader onOpenPalette={() => setPaletteOpen(true)} />
        <main
          key={location.pathname}
          className="flex-1 min-h-0 overflow-y-auto overscroll-contain"
          data-testid="app-main"
        >
          <Outlet />
        </main>
      </div>
      <CommandPalette open={paletteOpen} onOpenChange={setPaletteOpen} />
    </div>
  );
}
